import { useMutation } from '@tanstack/react-query'
import { registeredConsumersCount } from '../index'

const usePostRegisteredConsumersCount = () =>
  useMutation({
    mutationFn: registeredConsumersCount,
  })

export default usePostRegisteredConsumersCount
